import type { IconType } from '@kk/ui/components/Icon';
import Icon from '@kk/ui/components/Icon/Icon';
import { Link } from 'react-router-dom';

export interface TextLinkProps {
  to: string;
  text: string;
  iconType?: IconType;
  ariaLabel?: string;
  solid?: boolean;
}

const TextLink = ({ to, text, ariaLabel, iconType, solid }: TextLinkProps) => {
  return (
    <Link
      to={to}
      aria-label={ariaLabel || text}
      className={`text-blue-60 flex items-center underline`}
    >
      {iconType && (
        <Icon type={iconType} solid={solid} className="text-blue-60 mr-2" />
      )}
      <span>{text}</span>
    </Link>
  );
};

export default TextLink;
